import { GeocodeRequester, type LatLng } from '@cobliteam/api-lib';
import IncidentsRequester from '@cobliteam/api-lib/src/dashboard/incidents/IncidentsRequester';
import type { Incident, IncidentWithAddress } from '@cobliteam/common-types';
import { Environment } from '@cobliteam/react-environments';
import { loadAlarmsFailed, loadAlarmsSucceeded } from '@cobliteam/store/src/Alarms/actionCreators';
import type { LoadAlarmsRequest } from '@cobliteam/store/src/Alarms/actions';
import { ActionTypes } from '@cobliteam/store/src/Alarms/actionTypes';
import { all, call, put, takeLatest } from 'redux-saga/effects';

const env = Environment.getInstance().getEnvironment();

const incidentsRequester = new IncidentsRequester({ host: env.herbieApiHost });
const geocodeRequester = new GeocodeRequester({ host: env.herbieApiHost });

export const getAlarmsLatLng = (alarms: Incident[]): LatLng[] =>
  alarms.map((event) => ({
    lat: event.latitude,
    lng: event.longitude,
  }));

export const buildAlarmsWithAddressArray = (alarmsArray: Incident[], addresses: string[]): IncidentWithAddress[] => {
  let addressIndex = 0;
  return alarmsArray.map((notification) => {
    const notificationWithAddress = {
      ...notification,

      address: addresses[addressIndex++],
    };
    return notificationWithAddress;
  });
};

export function* loadAlarmsRequestSaga(action: LoadAlarmsRequest) {
  const { alarmsPayload } = action.payload;

  try {
    const incidents: Incident[] = yield call(incidentsRequester.getIncidents, alarmsPayload);
    const sortedIncidents = incidents.sort((a, b) => (a.date > b.date ? -1 : 1));
    const incidentsLatLng = getAlarmsLatLng(sortedIncidents);
    const addresses: string[] = yield call(geocodeRequester.getAddresses, incidentsLatLng);
    const incidentsWithAddress = buildAlarmsWithAddressArray(sortedIncidents, addresses);

    yield put(loadAlarmsSucceeded(incidentsWithAddress));
  } catch (err) {
    yield put(loadAlarmsFailed());
  }
}

export function* AlarmsSagasListener() {
  yield all([takeLatest(ActionTypes.LOAD_ALARMS_REQUEST, loadAlarmsRequestSaga)]);
}
